import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Instagram, Youtube, Twitter, MessageCircle, MapPin, Phone, Mail } from "lucide-react";
import ZeloLogo from "./ZeloLogo";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-white" data-testid="site-footer">
      <div className="container-zelo py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <ZeloLogo variant="white" size="xl" to="/" className="mb-5 -ml-1" />
            <p className="text-sm text-white/70 leading-relaxed">
              India's next-gen platform for retail leasing and pre-leased commercial real estate. Brand-fit spaces, signed-ready leases, and possession that doesn't slip.
            </p>
            <div className="flex gap-3 mt-6">
              <a href="https://x.com/zelolease?s=21" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-brand transition" data-testid="social-twitter" aria-label="X / Twitter"><Twitter className="w-4 h-4" /></a>
              <a href="https://www.linkedin.com/company/zelolease/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-brand transition" data-testid="social-linkedin" aria-label="LinkedIn"><Linkedin className="w-4 h-4" /></a>
              <a href="https://www.instagram.com/zelo.lease/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-brand transition" data-testid="social-instagram" aria-label="Instagram"><Instagram className="w-4 h-4" /></a>
              <a href="https://wa.me/918758115155" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-brand transition" data-testid="social-whatsapp" aria-label="WhatsApp"><MessageCircle className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white hover:text-brand transition" data-testid="social-youtube" aria-label="YouTube"><Youtube className="w-4 h-4" /></a>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="label-tiny text-white/50 mb-4">Company</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/retail-leasing" className="hover:text-brand-300 transition">Retail Leasing</Link></li>
              <li><Link to="/pre-leased" className="hover:text-brand-300 transition">Pre-Leased (Beta)</Link></li>
              <li><Link to="/broker" className="hover:text-brand-300 transition">For Brokers</Link></li>
              <li><Link to="/about" className="hover:text-brand-300 transition">About Us</Link></li>
              <li><Link to="/list-your-property" className="hover:text-brand-300 transition">List Your Property</Link></li>
              <li><Link to="/faq" className="hover:text-brand-300 transition">FAQs</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="label-tiny text-white/50 mb-4">Head Office · Ahmedabad</div>
            <div className="text-sm text-white/80 leading-relaxed">
              615, 6th Floor, Shivalik Shilp 2,<br />
              Opp. ITC Narmada, Keshavbaug,<br />
              Satellite, Ahmedabad,<br />
              Gujarat 380015.
            </div>
            <div className="label-tiny text-white/50 mt-6 mb-3">Mumbai Office</div>
            <div className="text-sm text-white/80 leading-relaxed">
              C-20, G Block Road,<br />
              G Block BKC, Bandra Kurla Complex,<br />
              Bandra East, Mumbai,<br />
              Maharashtra 400051.
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="label-tiny text-white/50 mb-4">Get in Touch</div>
            <ul className="space-y-4 text-sm text-white/80">
              <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 shrink-0 text-brand-300" />
                <div>
                  <div className="text-white">Mr. Aman Nainani</div>
                  <a href="tel:+918758115155" className="hover:text-white">+91 87581 15155</a>
                </div>
              </li>
              <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 shrink-0 text-brand-300" /><a href="mailto:aman@zelolease.com" className="hover:text-white">aman@zelolease.com</a></li>
              <li className="flex gap-3"><MessageCircle className="w-4 h-4 mt-0.5 shrink-0 text-brand-300" /><a href="https://wa.me/918758115155" target="_blank" rel="noopener noreferrer" className="hover:text-white">WhatsApp the team</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 justify-between text-xs text-white/50">
          <div>© {new Date().getFullYear()} Zelo Leaseworks LLP. All rights reserved.</div>
          <div className="flex gap-5">
            <Link to="/terms" className="hover:text-white">Terms & Conditions</Link>
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/consumer-policy" className="hover:text-white">Consumer Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
